<template>
  <el-dialog
    title="标签管理"
    :visible.sync="visible"
    @close="$emit('close')"
    width="550px"
    class="tag-manage"
  >
    <div class="tag-list">
      <el-row
        type="flex"
        class="tag-row"
        v-for="(tag, index) in tagLists"
        :key="'tag' + index"
      >
        <el-col :span="2">
          <i class="iconfont icontag" :style="{ color: tag.tagColour }"></i>
        </el-col>
        <el-col :span="18" style="padding: 0 10px">
          <template v-if="!tag.edit">
            <p>{{ tag.tagName }}</p>
          </template>
          <template v-else>
            <el-col :span="20">
              <el-input size="mini" v-model="tag.tagName"></el-input>
            </el-col>
            <el-col :span="4" class="text-center">
              <el-color-picker
                v-model="tag.tagColour"
                size="small"
              ></el-color-picker>
            </el-col>
          </template>
        </el-col>
        <el-col :span="2" class="text-center">
          <a
            class="pointer"
            style="color: #009899"
            v-show="!tag.edit"
            @click="tag.edit = true"
            >编辑</a
          >
          <a
            class="pointer"
            style="color: #009899"
            v-show="tag.edit"
            @click="saveTag(tag)"
            >保存</a
          >
        </el-col>
        <el-col :span="2" class="text-center">
          <a
            class="pointer"
            style="color: #ec1c1c"
            @click="deleteTag(tag, index)"
            >删除</a
          >
        </el-col>
      </el-row>
    </div>
    <div class="text-right margin-t-30">
      <el-button @click="addTag" type="primary" size="small"
        >+新增标签</el-button
      >
      <el-button size="small" @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ApiMethods } from '@/assets/js/http-serve/http-methods';

export default {
  name: 'index',
  props: ['isCrop'],
  data () {
    return {
      visible: false,
      tagLists: [],
    };
  },
  created () {
    this.getTagList();
  },
  methods: {
    setVisible (bol) {
      this.visible = bol;
    },
    getTagList () {
      ApiMethods[this.isCrop ? 'CorpUserTagController' : 'UserTagController'].getAllUserTagList().then(res => {
        if (!res.success && this.$store.getters.authUser.identityAuth > -1) return this.$message.error(res.description || this.$tip);
        if (res.data) {
          this.tagLists = res.data.map(i => {
            i.edit = false;
            i.local = false;
            return i;
          });
        }
      });
    },
    addTag () {
      this.tagLists.push({ edit: true, tagColour: '#333333', tagName: '', local: true });
    },
    saveTag (tag) {
      tag.local ? this.addUserTag(tag) : this.updateUserTag(tag);
    },
    addUserTag (tag) {
      ApiMethods[this.isCrop ? 'CorpUserTagController' : 'UserTagController'].addUserTag({
        tagName: tag.tagName,
        tagColour: tag.tagColour,
      }).then(res => {
        if (!res.success) return this.$message.error(res.description || '操作失败');
        tag.edit = false;
        tag.local = false;
        tag.userTagId = res.data;
        this.$emit('refresh');
      });
    },
    updateUserTag (tag) {
      ApiMethods[this.isCrop ? 'CorpUserTagController' : 'UserTagController'].updateUserTag({
        userTagId: tag.userTagId,
        tagName: tag.tagName,
        tagColour: tag.tagColour,
      }).then(res => {
        if (!res.success) return this.$message.error(res.description || '操作失败');
        tag.edit = false;
        tag.local = false;
        this.$emit('refresh');
      });
    },

    setTag (tag, row, signType) {//0发件箱，1收件箱
      const signId = +signType === 0 ? row.applyId : row.signInfoId;
      const cropSignId = row.applyId;
      return ApiMethods[this.isCrop ? 'CorpUserTagController' : 'UserTagController'].saveSignTag({
        userTagIds: (tag || {}).userTagId,
        signId: this.isCrop ? cropSignId : signId,
        signType: signType,
      });
    },
    deleteTag (tag, index) {
      if (!tag.local) {
        return this.$confirm('是否删除标签？删除后被标记的文件将取消该标签。').then(_ => {
          this.deleteUserTag(tag, index);
        }).catch(_ => { });
      }
      this.tagLists.splice(index, 1);
    },
    deleteUserTag (tag, index) {
      ApiMethods[this.isCrop ? 'CorpUserTagController' : 'UserTagController'].deleteUserTag({
        userTagIds: tag.userTagId,
      }).then(res => {
        if (!res.success) return this.$message.error(res.description || '操作失败');
        this.tagLists.splice(index, 1);
        this.$emit('refresh');
      });
    },
  },
};
</script>

<style lang="less" scoped>
.tag-manage {
}

.tag-list {
  height: 400px;
  overflow-y: auto;
}

.tag-row {
  padding: 0 20px;
  height: 32px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// components/tag-manage/index.vue